//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.BaseBuilder.js";
let d=[[[0,"DirectionPatternType",1,0],[0,"DirectionVector",1,"Direction",0],[0,"Feature",1,"Features.PatternFeature",0],[0,"OptimizationType",1,0],[0,"OutputForSubroutines",1,0],[0,"OutputOrderType",1,0],[0,"PatternMcs",1,0]],[[[],"Reorder",{},0,0],[[],"Reverse",{},0,0],[[],"Reload",{},0,0]],[]];
SPLM.CAM.ProcessPatterning = class extends SPLM.CAM.BaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ProcessPatterning";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ProcessPatterning.OptimizationTypes = Object.freeze({
    "Closest" : "Closest", "Shortest" : "Shortest", "Direction" : "Direction"});

SPLM.CAM.ProcessPatterning.DirectionPatternTypes = Object.freeze({
    "Zig" : "Zig", "Zigzag" : "Zigzag"});

SPLM.CAM.ProcessPatterning.OutputOrderTypes = Object.freeze({
    "AllOperations" : "AllOperations", "AllInstances" : "AllInstances"});

export default SPLM;